import queryString from 'query-string'
import { fetchingAPI, apiService } from '@/api'
import { toast } from '@/components/toasts/toast.helpers'

import * as redux from './outboundScheduledCalls.redux'

export const SCHEDULED_CALLS_PER_PAGE = 25

export const fetchScheduledCalls =
  ({ limit = SCHEDULED_CALLS_PER_PAGE, offset = 0 } = {}) =>
  async (dispatch) => {
    dispatch(redux.setLoading({ scheduledCalls: true }))
    try {
      const params = queryString.stringify({ limit, offset })
      const response = await fetchingAPI(
        `${apiService.core}/api/scheduled_calls?${params}`,
        'GET',
        dispatch
      )

      dispatch(redux.setScheduledCalls(response || { scheduled_calls: [], total: 0, offset }))
    } catch (error) {
      toast.error('Failed to fetch scheduled calls', { cause: error })
    } finally {
      dispatch(redux.setLoading({ scheduledCalls: false }))
    }
  }

export const createScheduledCall = (scheduledCallData) => async (dispatch) => {
  try {
    const response = await fetchingAPI(
      `${apiService.core}/api/scheduled_calls`,
      'POST',
      dispatch,
      JSON.stringify(scheduledCallData)
    )

    toast.success('Call scheduled successfully')
    return response
  } catch (error) {
    // core-service returns the validation reason (e.g. time out of window, not in
    // the future) as the error message, so surface it rather than a generic string.
    toast.error(`Failed to schedule call.${error?.message ? ` ${error.message}` : ''}`, {
      cause: error,
    })
    throw error
  }
}

export const cancelScheduledCall = (scheduledCallId) => async (dispatch, getState) => {
  try {
    await fetchingAPI(
      `${apiService.core}/api/scheduled_calls/${scheduledCallId}`,
      'DELETE',
      dispatch
    )

    toast.success('Scheduled call cancelled')
    // Reload the page the user is on rather than jumping back to the first page. If the
    // cancelled row was the only one on a non-first page, step back so they don't land on
    // a now-empty page.
    const { scheduledCalls, offset } = getState().outboundScheduledCalls.data
    const nextOffset =
      scheduledCalls.length === 1 && offset > 0 ? offset - SCHEDULED_CALLS_PER_PAGE : offset
    dispatch(fetchScheduledCalls({ offset: Math.max(0, nextOffset) }))
  } catch (error) {
    // A 409 means the call was already dialed; surface that reason over a generic message.
    toast.error(`Failed to cancel scheduled call.${error?.detail ? ` ${error.detail}` : ''}`, {
      cause: error,
    })
  }
}
